export default __webpack_public_path__ + "static/media/link.0a48c55c.svg";